import { types } from "../action-types";

const initialState = {
  loading: false,
  roles: [],
  error: false,
};

const roleReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_GIG_ROLES_REQUESTED:
      return {
        ...state,
        loading: true,
      };

    case types.GET_GIG_ROLES_SUCCESS:
      return {
        ...state,
        loading: false,
        roles: action.payload,
        error: false,
      };
    case types. GET_GIG_ROLES_FAILURE:
      return {
        ...state,
        loading: false,
        roles: [],
        error: true,
      };
    default:
      return state;
  }
};

export default roleReducer;
